import { API_URL } from '@/config/env';
import { conformanceApi, inventoryApi } from '@/lib/api';
import { hasCheckpointVersionValue } from '@/lib/checkpointKeys';

import type { Application } from './application.types';
import type {
  ApplicationConfiguration,
  CheckpointParametersRequest,
} from './applicationConfiguration.types';

export const fetchApplications = () => {
  return inventoryApi.get<Application[]>('/applications');
};

export const fetchApplicationConfigurations = async (bitId: string) => {
  const response = await conformanceApi.get<{
    data: ApplicationConfiguration[];
    message: string;
    status: string;
  }>(`${API_URL}/${bitId}/configurations`);

  return response.data.data;
};

export const createApplicationConfiguration = ({
  bitId,
  configurationId,
}: {
  bitId: string;
  configurationId?: string;
}) => {
  return conformanceApi.post<{
    data: ApplicationConfiguration[];
    message: string;
    status: string;
  }>(`${API_URL}/${bitId}/configurations`, null, {
    params: { SourceConfigurationId: configurationId },
  });
};

export const updateCheckpointParameters = ({
  bitId,
  configurationId,
  checkpointId,
  checkpointVersion,
  parameters,
}: CheckpointParametersRequest) => {
  const hasCheckpointVersion = hasCheckpointVersionValue(checkpointVersion);

  const endpoint = hasCheckpointVersion
    ? `${API_URL}/${bitId}/configurations/${configurationId}/checkpoints/${checkpointId}/versions/${encodeURIComponent(
        `${checkpointVersion}`,
      )}/parameters`
    : `${API_URL}/${bitId}/configurations/${configurationId}/checkpoints/${checkpointId}/parameters`;

  return conformanceApi.post<ApplicationConfiguration>(endpoint, parameters);
};

export const saveApplicationConfiguration = ({
  bitId,
  configurationId,
}: {
  bitId: string;
  configurationId: string;
}) => {
  return conformanceApi.put<{
    data: ApplicationConfiguration[];
    message: string;
    status: string;
  }>(`${API_URL}/${bitId}/configurations/${configurationId}`, {
    isDraft: false,
  });
};

export const deleteApplicationConfiguration = ({
  bitId,
  configurationId,
}: {
  bitId: string;
  configurationId: string;
}) => {
  return conformanceApi.delete<{
    data: ApplicationConfiguration[];
    message: string;
    status: string;
  }>(`${API_URL}/${bitId}/configurations/${configurationId}`);
};
